import React from 'react';

const DateTimeCell = ({ item }) => (
    <div className="flex justify-between">
        <span className="text-muted-foreground max-w-[85px]">
            {new Date(item.ts ?? item.lastUpdatedTime).toLocaleString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            })}
        </span>
        {'-'}
        <span className="text-muted-foreground max-w-[85px]">
            {new Date(item.ts ?? item.lastUpdatedTime).toLocaleString('en-US', {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                hour12: true,
            })}
        </span>
    </div>
);

export default DateTimeCell;
